var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12291123WavyTech24Single01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2812,
    height: 2800,
    viewBox: "0 0 2812 2800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M675.903 168.292C581.471 303.476 692.195 522.643 552.074 624.313C415.677 723.281 248.118 561.059 119.573 646.25C-71.1174 772.626 -36.2934 1350.9 242.505 1710.19C326.349 1818.24 396.406 1860.28 427.434 1982.49C494.059 2244.88 259.904 2400.97 304.463 2530.75C404.795 2822.96 1947.83 3068.16 2566.96 2189.97C2856.12 1779.82 2899.39 1187.56 2641.03 737.731C2174.19 -75.098 887.791 -135.037 675.903 168.292Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 694,
    y: 250,
    width: 632,
    height: 1365
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.2 1614.94L1325.69 1519.97C1325.69 1519.97 1314.15 1400.79 1231.38 1352.57C1062.49 1254.18 1160.45 1113.13 1192.64 1047.91C1241.19 949.566 1241.08 841.724 1108.28 858.608C975.487 875.492 1005.21 642.809 1106.51 495.275C1205.63 350.903 1006.19 91.3878 762.956 384.165C617.696 559.01 741.832 742.469 782.494 850.017C823.157 957.565 673.73 1039.93 786.916 1140.78C883.597 1226.91 1006.64 1264.45 977.175 1369.81C947.707 1475.16 980.9 1561.43 1128.2 1614.94Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1128.2 1614.94L1325.69 1519.97C1325.69 1519.97 1314.15 1400.79 1231.38 1352.57C1062.49 1254.18 1160.45 1113.13 1192.64 1047.91C1241.19 949.566 1237.65 854.36 1119.49 848.313C985.793 841.471 1005.21 642.809 1106.51 495.275C1205.63 350.903 1006.19 91.3878 762.956 384.165C617.696 559.01 741.832 742.469 782.494 850.017C823.157 957.565 673.73 1039.93 786.916 1140.78C883.597 1226.91 1006.64 1264.45 977.175 1369.81C947.707 1475.16 980.9 1561.43 1128.2 1614.94Z",
    fill: "url(#paint0_linear_248_90)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_248_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 694,
    y: 250,
    width: 632,
    height: 1365
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.2 1614.94L1325.69 1519.97C1325.69 1519.97 1314.15 1400.79 1231.38 1352.57C1062.49 1254.18 1160.45 1113.13 1192.64 1047.91C1241.19 949.566 1241.08 841.724 1108.28 858.608C975.487 875.492 1005.21 642.809 1106.51 495.275C1205.63 350.903 1006.19 91.3878 762.956 384.165C617.696 559.01 741.832 742.469 782.494 850.017C823.157 957.565 673.73 1039.93 786.916 1140.78C883.597 1226.91 1006.64 1264.45 977.175 1369.81C947.707 1475.16 980.9 1561.43 1128.2 1614.94Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_248_90)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222.49 1592.17L1226.23 1589.44C1224.54 1587.13 1056.49 1354.64 959.385 1073.93C869.924 815.317 824.131 461.671 1114 245.514L1111.24 241.805C982.2 338.028 907.803 469.016 890.11 631.13C875.977 760.632 897.823 910.148 955.042 1075.53C1052.39 1356.87 1220.8 1589.84 1222.49 1592.17Z",
    fill: "#B9B8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.644 699.193L889.534 696.686C806.178 567.23 764.583 346.402 764.172 344.188L759.623 345.029C760.036 347.255 801.799 568.978 885.644 699.193Z",
    fill: "#B9B8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.393 591.5C998.693 436.573 1149.99 415.478 1151.51 415.284L1150.92 410.697C1149.38 410.892 995.993 432.196 896.487 589.022L900.393 591.5Z",
    fill: "#B9B8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.87 1253.99C984.965 1035.01 1229.12 858.249 1231.65 856.726L1229.52 852.622C1226.91 853.882 980.02 1034.05 1028.35 1254.97L1032.87 1253.99Z",
    fill: "#B9B8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.529 1171.31L995.203 1168.5C908.266 1054.91 729.608 1033.9 727.812 1033.7L727.302 1038.3C729.079 1038.5 905.809 1059.31 991.529 1171.31Z",
    fill: "#B9B8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.59 1552.28C1169.82 1472.88 1249.92 1359.78 1250.73 1358.64L1246.97 1355.95C1243.59 1360.65 1164.59 1472.21 1196.28 1553.95L1200.59 1552.28Z",
    fill: "#B9B8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.05 1497.75L1163.83 1495.08C1124.85 1440.17 1002.4 1417.02 962.164 1409.41C956.477 1408.33 951.569 1407.4 950.727 1407.06L948.945 1411.33C950.126 1411.83 953.387 1412.45 961.305 1413.95C1001.09 1421.48 1122.16 1444.37 1160.05 1497.75Z",
    fill: "#B9B8F2"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M932.742 1420.8C1000.37 1423.29 1008.08 1482.98 1030.07 1525.73C1026.87 1531.39 1026.47 1535.46 1024.51 1541.87C1006.85 1599.68 986.998 1620.58 960.592 1674.81C954.908 1686.48 927.804 1715.67 915.964 1726.89L893.557 1747.44C893.557 1747.44 739.767 1722.69 744.121 1634.15C748.475 1545.61 605.395 1503.57 532.341 1471.96C487.481 1452.55 473.183 1429.3 457.845 1419.52C295.475 1316.01 217.52 1338.88 185.399 1272.79C149.939 1199.82 234.791 1151.06 200.41 1069.64C161.586 977.715 27.3255 978.174 10.0265 882.968C7.06054 866.645 4.45753 849.794 9.36653 828.215C21.4845 774.953 68.9036 752.639 49.4636 698.971C10.3876 591.097 44.5085 468.419 160.755 446.795C275.483 425.453 387.314 586.301 402.879 845.229C434.942 1028.11 465.143 1046.91 547.169 1077.92C604.622 1099.65 774.782 1120.48 786.386 1227.09C797.99 1333.7 855.424 1417.96 932.742 1420.8Z",
    fill: "url(#paint1_linear_248_90)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_248_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 444,
    width: 1049,
    height: 1302
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.16 1582.34L900.632 1745.75C900.632 1745.75 739.768 1722.69 744.122 1634.15C748.476 1545.61 605.397 1503.57 532.342 1471.96C334.127 1386.19 475.28 1179.17 230.813 1047.57C165.792 1012.57 28.5816 968.822 10.0266 882.967C-11.1124 785.153 74.4636 767.988 49.4626 698.97C10.3866 591.096 44.5086 468.417 160.754 446.793C275.482 425.451 387.313 586.299 402.879 845.226C434.942 1028.1 465.144 1046.91 547.169 1077.92C604.623 1099.64 774.784 1120.47 786.388 1227.09C797.992 1333.7 824.447 1424.63 901.764 1427.48C1019.41 1431.8 1054.16 1582.34 1054.16 1582.34Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_248_90)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M978.194 1648.64L975.555 1652.22C955.673 1637.83 935.815 1623.06 916.535 1608.31C773.787 1499.11 647.29 1379.53 540.555 1252.9C450.116 1145.6 372.568 1031.74 310.066 914.489C259.802 820.197 218.95 723.208 188.647 626.216C167.346 558.031 151.435 490.551 141.365 425.646C139.608 414.336 138.444 402.621 137.318 391.292C135.819 376.197 134.269 360.589 131.3 345.818L135.472 344.656C138.481 359.63 140.043 375.344 141.553 390.541C142.673 401.814 143.831 413.471 145.57 424.666C155.61 489.366 171.471 556.646 192.714 624.637C222.941 721.388 263.697 818.146 313.846 912.221C376.22 1029.23 453.614 1142.86 543.878 1249.95C650.432 1376.37 776.729 1495.76 919.257 1604.79C938.508 1619.52 958.337 1634.27 978.194 1648.64Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.943 1051.21L392.401 1053.87C291.268 907.793 -5.1984 829.166 -8.1814 828.39L-6.8374 824.203C-3.8404 824.984 294 903.968 395.943 1051.21Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.138 1431.89L712.895 1434.92C632.075 1344.71 668.9 1102 669.28 1099.56L673.483 1099.92C673.104 1102.34 636.58 1343.09 716.138 1431.89Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.668 1478.71L763.96 1482.24C701.035 1434.56 587.496 1405.66 444.265 1400.88C437.062 1400.64 437.062 1400.64 436.432 1400.18L439.099 1396.62L437.766 1398.4L438.379 1396.3C438.853 1396.37 441.572 1396.46 444.724 1396.57C588.774 1401.38 703.108 1430.55 766.668 1478.71Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.316 1621.84L938.784 1624.5C888.729 1552.87 928.282 1421.13 928.686 1419.81L932.742 1420.8C932.343 1422.11 893.408 1551.84 942.316 1621.84Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.142 1654.61C906.425 1636.68 828.878 1638.62 738.073 1660.55L737.388 1656.35C828.891 1634.25 907.102 1632.32 976.488 1650.42L975.142 1654.61Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.507 681.392L207.84 683.851C156.323 599.107 81.8786 523.711 57.4156 498.935C51.4936 492.938 49.4166 490.819 48.8296 489.944L52.4046 487.338C52.8626 488 56.2476 491.428 60.5336 495.768C85.0746 520.624 159.755 596.261 211.507 681.392Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.187 833.326L270.047 834.632C248.089 742.444 348.795 570.93 353.093 563.673L356.696 565.687C355.654 567.447 252.639 742.859 274.187 833.326Z",
    fill: "#FCFDFE"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1010 1419.42C1002.87 1428.13 1048.68 1460.73 968.888 1449.06C1015.34 1380.5 948.955 1446.14 968.888 1449.06C959.871 1462.37 786.856 1367.08 777.839 1380.39C739.92 1372.93 705.564 1358.88 719.747 1310.23C741.774 1234.69 634.765 1167.52 585.489 1161.96C524.501 1155.07 382.984 1136.06 415.249 1018.84C442.108 921.256 478.861 862.718 381.221 795.416C283.58 728.113 256.765 631.769 323.201 539.131C393.116 441.643 316.607 280.38 411.721 223.501C577.454 124.396 718.388 391.045 672.66 606.26C626.933 821.473 750.706 757.288 836.552 802.893C844.281 807.578 855.903 815.438 867.859 827.318C941.466 900.463 900.111 999.249 930.182 1107.3C971.194 1254.66 1022.02 1404.74 1010 1419.42Z",
    fill: "url(#paint2_linear_248_90)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_248_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 286,
    y: 202,
    width: 662,
    height: 1186
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M947.042 1167.83L806.859 1387.64C769.038 1382.08 703.905 1364.57 719.748 1310.23C741.774 1234.69 634.766 1167.52 585.49 1161.96C524.502 1155.07 382.984 1136.06 415.249 1018.84C442.109 921.255 478.862 862.718 381.221 795.416C283.581 728.113 256.765 631.769 323.202 539.131C393.116 441.644 316.606 280.381 411.722 223.503C577.456 124.396 718.387 391.046 672.661 606.26C626.934 821.474 750.706 757.289 836.553 802.895C953.753 865.156 828.964 1010.85 846.832 1080.22C860.839 1134.6 912.784 1157.65 947.042 1167.83Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_248_90)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.085 1250.93L844.228 1255.06C561.495 986.225 417.012 572.144 467.164 174.414L472.581 174.807C422.64 570.861 566.525 983.209 848.085 1250.93Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.108 1090.26L704.091 1095.03C573.281 1014.89 397.088 1069.89 395.324 1070.45L393.95 1065.19C395.736 1064.61 574.234 1008.86 707.108 1090.26Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.488 1199.96L792.671 1202.84C717.692 1065.29 860.888 802.43 862.345 799.791L867.079 802.274C865.639 804.883 723.935 1065.03 797.488 1199.96Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.925 747.067L526.345 750.341C457.579 647.299 267.307 622.388 265.393 622.148L266.361 616.659C268.299 616.901 460.889 642.12 530.925 747.067Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.57 500.638L468.11 500.764C473.032 355.188 612.556 210.519 613.968 209.074L617.746 212.845C616.35 214.271 478.414 357.331 473.57 500.638Z",
    fill: "#FCFDFE"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2620.73 1993.4L2564.42 1993.49C2560.54 1956.3 2551.6 1920.6 2538.29 1887.05L2585.9 1859.44C2598.91 1851.9 2603.36 1834.88 2595.86 1821.39L2575.86 1785.42C2568.31 1771.85 2551.55 1766.86 2538.41 1774.32L2491.39 1801.01C2469.51 1770.35 2443.39 1742.7 2413.81 1718.92L2440.85 1672.47C2448.61 1659.14 2444.01 1641.6 2430.55 1633.25L2394.56 1610.92C2380.95 1602.48 2363.5 1606.46 2355.59 1619.87L2328.49 1665.85C2293.66 1649.63 2256.03 1637.93 2216.34 1631.65V1577.13C2216.34 1561.04 2203.11 1547.4 2186.74 1546.65L2142.92 1544.65C2126.33 1543.9 2112.85 1556.46 2112.85 1572.72V1627.85C2071.93 1631.25 2032.49 1640.45 1995.41 1654.68L1966.16 1604.85C1957.56 1590.21 1938.47 1584.53 1923.49 1592.21L1883.41 1612.77C1868.26 1620.54 1863.06 1638.83 1871.82 1653.57L1902.13 1704.55C1868.96 1728.01 1839.3 1756.08 1814.19 1787.91L1759.37 1756.9C1743.82 1748.1 1723.88 1752.66 1714.85 1767.13L1690.75 1805.73C1681.66 1820.29 1687.05 1839.19 1702.77 1847.89L1759.5 1879.28C1743.77 1915.5 1733.15 1954.33 1728.52 1994.93L1660.48 1995.05C1642.17 1995.08 1627.27 2008.96 1627.27 2026.05V2071.5C1627.27 2088.59 1642.17 2102.26 1660.48 2102.03L1730.33 2101.16C1736.23 2140.81 1747.87 2178.55 1764.43 2213.6L1702.77 2248.59C1687.05 2257.51 1681.65 2276.49 1690.75 2290.92L1714.85 2329.18C1723.88 2343.52 1743.82 2347.79 1759.37 2338.78L1821.72 2302.62C1846.64 2332.08 1875.62 2357.98 1907.77 2379.53L1871.82 2440.51C1863.06 2455.38 1868.26 2473.6 1883.41 2481.15L1923.49 2501.14C1938.47 2508.61 1957.56 2502.66 1966.16 2487.9L2001.81 2426.65C2037.02 2439.07 2074.28 2446.95 2112.85 2449.67V2517.95C2112.85 2534.21 2126.33 2546.58 2142.92 2545.59L2186.74 2542.97C2203.11 2541.99 2216.34 2528.16 2216.34 2512.08V2444.54C2253.77 2438.14 2289.37 2426.94 2322.51 2411.71L2355.59 2467.36C2363.5 2480.66 2380.95 2484.4 2394.56 2475.76L2430.55 2452.92C2444.01 2444.38 2448.61 2426.78 2440.85 2413.56L2408.74 2358.85C2437.49 2336.1 2463.08 2309.79 2484.85 2280.68L2538.41 2310.32C2551.55 2317.59 2568.31 2312.37 2575.86 2298.7L2595.86 2262.44C2603.36 2248.84 2598.91 2231.89 2585.9 2224.53L2534.11 2195.23C2548.14 2162.32 2557.95 2127.29 2562.9 2090.8L2620.73 2090.08C2635.63 2089.9 2647.68 2077.31 2647.68 2061.96V2021.14C2647.68 2005.79 2635.63 1993.37 2620.73 1993.4ZM2164.88 2329.4C1998.26 2335.58 1858.84 2206.27 1858.84 2040.38C1858.84 1874.49 1998.26 1743.4 2164.88 1747.45C2325.83 1751.36 2452.34 1880.76 2452.34 2036.59C2452.34 2192.41 2325.83 2323.43 2164.88 2329.4Z",
    fill: "#97A6B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1978.44 1590.08L1938.34 1588.69L1924.51 1624.65L1978.44 1590.08Z",
    fill: "#97A6B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2376.11 1606.67L2422.35 1607.13V1641.24L2376.11 1606.67Z",
    fill: "#97A6B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2552.34 1771.22L2598.44 1773.08L2586.91 1798.89L2552.34 1771.22Z",
    fill: "#97A6B7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2624.71 1993.88L2671.27 1997.56L2656.06 2020.15L2624.71 1993.88Z",
    fill: "#97A6B7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2547.27 2313.32L2592.44 2319.78L2597.98 2282.9L2547.27 2313.32Z",
    fill: "#97A6B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2374.41 2479.73L2414.97 2487.1L2418.2 2457.14L2374.41 2479.73Z",
    fill: "#97A6B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.59 2551.64L2135.17 2545.19L2166.52 2498.63L2171.59 2551.64Z",
    fill: "#97A6B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1974.3 2512.46L1931.89 2503.7L1964.62 2464.06L1974.3 2512.46Z",
    fill: "#97A6B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1735.98 1752.8L1780.23 1754.18L1762.72 1786.45L1735.98 1752.8Z",
    fill: "#97A6B7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.94 2099.9L1688.5 2105.89L1685.27 2072.7L1647.94 2099.9Z",
    fill: "#97A6B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1735.06 2342.82L1774.7 2349.28L1777.93 2323L1735.06 2342.82Z",
    fill: "#97A6B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2666.22 1997.05L2609.45 1997.15C2605.53 1959.65 2596.52 1923.66 2583.1 1889.84L2631.11 1862.01C2644.22 1854.4 2648.71 1837.24 2641.15 1823.65L2620.98 1787.38C2613.37 1773.7 2596.47 1768.67 2583.22 1776.2L2535.81 1803.1C2513.75 1772.18 2487.42 1744.31 2457.59 1720.34L2484.86 1673.51C2492.68 1660.07 2488.04 1642.39 2474.47 1633.97L2438.18 1611.46C2424.46 1602.95 2406.86 1606.97 2398.89 1620.49L2371.56 1666.84C2336.45 1650.48 2298.5 1638.69 2258.48 1632.36V1577.39C2258.48 1561.17 2245.14 1547.42 2228.63 1546.67L2184.45 1544.65C2167.73 1543.89 2154.13 1556.56 2154.13 1572.95V1628.52C2112.87 1631.96 2073.1 1641.23 2035.72 1655.58L2006.22 1605.34C1997.56 1590.58 1978.31 1584.85 1963.2 1592.6L1922.8 1613.32C1907.52 1621.16 1902.27 1639.59 1911.11 1654.46L1941.67 1705.85C1908.22 1729.5 1878.32 1757.8 1852.99 1789.89L1797.72 1758.63C1782.05 1749.76 1761.94 1754.36 1752.83 1768.94L1728.53 1807.85C1719.36 1822.53 1724.81 1841.59 1740.66 1850.36L1797.85 1882C1781.99 1918.52 1771.28 1957.67 1766.62 1998.6L1698.02 1998.72C1679.55 1998.75 1664.53 2012.74 1664.53 2029.97V2075.79C1664.53 2093.02 1679.55 2106.8 1698.02 2106.57L1768.44 2105.69C1774.39 2145.67 1786.13 2183.72 1802.82 2219.05L1740.66 2254.32C1724.81 2263.32 1719.37 2282.45 1728.53 2297L1752.83 2335.57C1761.94 2350.02 1782.05 2354.34 1797.72 2345.25L1860.6 2308.79C1885.72 2338.5 1914.94 2364.6 1947.36 2386.33L1911.11 2447.81C1902.27 2462.8 1907.52 2481.16 1922.8 2488.78L1963.2 2508.93C1978.31 2516.46 1997.56 2510.47 2006.23 2495.58L2042.18 2433.83C2077.67 2446.35 2115.24 2454.3 2154.13 2457.04V2525.88C2154.13 2542.27 2167.73 2554.75 2184.45 2553.75L2228.63 2551.1C2245.14 2550.12 2258.48 2536.18 2258.48 2519.96V2451.87C2296.22 2445.42 2332.12 2434.13 2365.53 2418.78L2398.89 2474.88C2406.86 2488.28 2424.46 2492.05 2438.18 2483.35L2474.47 2460.32C2488.04 2451.71 2492.68 2433.96 2484.86 2420.64L2452.48 2365.48C2481.46 2342.55 2507.26 2316.02 2529.21 2286.67L2583.22 2316.56C2596.47 2323.89 2613.37 2318.63 2620.98 2304.84L2641.15 2268.28C2648.71 2254.58 2644.22 2237.49 2631.11 2230.07L2578.88 2200.52C2593.03 2167.35 2602.92 2132.04 2607.92 2095.25L2666.22 2094.53C2681.25 2094.34 2693.39 2081.64 2693.39 2066.17V2025.02C2693.39 2009.55 2681.25 1997.02 2666.22 1997.05ZM2206.59 2335.79C2038.6 2342.02 1898.01 2211.66 1898.01 2044.42C1898.01 1877.17 2038.6 1745.02 2206.59 1749.1C2368.87 1753.05 2496.44 1883.5 2496.44 2040.59C2496.44 2197.69 2368.87 2329.77 2206.59 2335.79Z",
    fill: "#D8DEE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1958.26 1848.78C1921.76 1849.83 1886.15 1840.63 1855.3 1822.15C1761.32 1765.81 1622.47 1672.78 1497.54 1551C1339.01 1396.47 1247.93 1239.39 1228.01 1085.13L1227.69 1082.72L1223.83 424.537C1223.83 294.46 1308.67 188.872 1467.96 119.491C1599.56 62.1693 1773.99 33.7662 1958.26 39.1002C2140.39 44.3722 2308.92 81.9512 2433.66 144.567C2581.94 219.002 2659.74 323.606 2659.74 447.625L2656.22 1076.52L2655.93 1078.83C2637.72 1226.54 2553.92 1379.23 2405.81 1533.62C2287 1657.46 2152.76 1755.59 2060.56 1816.4C2030.06 1836.52 1994.69 1847.72 1958.26 1848.78Z",
    fill: "url(#paint3_linear_248_90)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1994.41 1848.78C1958.38 1849.83 1923.24 1840.63 1892.8 1822.15C1800.07 1765.81 1663.04 1672.78 1539.77 1551C1383.34 1396.47 1293.46 1239.39 1273.8 1085.13L1273.49 1082.72L1269.67 424.537C1269.67 294.46 1353.4 188.872 1510.58 119.491C1640.44 62.1693 1812.57 33.7662 1994.41 39.1002C2174.13 44.3722 2340.43 81.9512 2463.52 144.567C2609.85 219.002 2686.62 323.606 2686.62 447.625L2683.14 1076.52L2682.86 1078.83C2664.89 1226.54 2582.19 1379.23 2436.04 1533.62C2318.8 1657.46 2186.33 1755.59 2095.35 1816.4C2065.25 1836.52 2030.35 1847.72 1994.41 1848.78Z",
    fill: "url(#paint4_linear_248_90)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.13 425.008L1316.97 1079.86C1360.08 1413.99 1752.75 1684.5 1923.77 1787.28C1972.76 1816.73 2035.4 1814.98 2084.05 1782.97C2251.5 1672.78 2622.66 1395.39 2662.32 1074.14L2665.84 446.977C2665.84 -18.325 1313.13 -60.8629 1313.13 425.008Z",
    fill: "url(#paint5_linear_248_90)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2004.11 1686.34C2000.98 1686.42 1996.23 1685.9 1991.44 1682.99C1921.02 1640.35 1784.52 1551.03 1665.77 1434.38C1537.5 1308.39 1463.52 1185.89 1446.56 1070.83L1442.79 426.82C1442.95 365.027 1491.86 312.143 1587.75 269.827C1694.79 222.586 1846.79 197.797 2004.11 201.534C2159.86 205.231 2307.44 236.585 2409.67 287.317C2500.11 332.19 2545.83 385.091 2545.97 444.747L2542.47 1066.46C2526.63 1177.8 2457.2 1297.82 2335.29 1423.99C2220.66 1542.62 2086.76 1636.66 2016.77 1682.4C2011.99 1685.52 2007.25 1686.27 2004.11 1686.34Z",
    fill: "url(#paint6_linear_248_90)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1988.04 1642.32C1916.93 1598.53 1790.48 1513.95 1680.15 1405.37C1559.6 1286.74 1489.84 1172.9 1473.44 1067.56L1469.71 427.287C1469.82 383.106 1510.43 342.579 1590.11 307.303C1691.51 262.405 1836.78 238.747 1988.04 242.142C2137.85 245.506 2279.06 275.095 2376.09 323.106C2451.49 360.41 2489.63 401.102 2489.74 444.192L2486.24 1063.62C2470.85 1165.82 2405.05 1277.59 2289.99 1396.46C2183.16 1506.82 2058.84 1595.56 1988.04 1642.32Z",
    fill: "#F4F7FA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2242.5 804.034L1763.63 808.294C1726.81 808.622 1696.82 837.319 1696.82 872.372V1179.19C1696.82 1214.04 1726.7 1241.05 1763.38 1239.55L2240.56 1220.01C2274.5 1218.62 2302.03 1190.52 2302.2 1157.23L2303.72 864.122C2303.89 830.643 2276.55 803.732 2242.5 804.034Z",
    fill: "url(#paint7_linear_248_90)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2068.59 979.975C2068.69 946.089 2039.61 919.302 2004.1 921.548C1972.65 923.533 1946.57 948.926 1944.81 979.398C1943.44 1003.03 1956.22 1023.51 1975.68 1033.91C1983.96 1038.32 1988.05 1047.59 1986.42 1056.73L1972.58 1134.24C1970.81 1144.1 1978.63 1152.78 1988.94 1152.42L2023.98 1151.19C2034.22 1150.83 2042.01 1141.66 2040.32 1131.96L2026.93 1055.19C2025.33 1046.02 2030.05 1036.93 2038.36 1031.94C2056.4 1021.08 2068.52 1001.76 2068.59 979.975Z",
    fill: "url(#paint8_linear_248_90)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2235.77 773.602C2221.39 773.696 2209.76 762.27 2209.82 748.079L2210.11 681.244C2210.41 614.118 2154.91 558.896 2085.75 558.21L1929.44 556.659C1857.87 555.947 1799.01 611.763 1798.95 681.012L1798.89 749.958C1798.88 764.597 1786.42 776.545 1771.02 776.645C1755.59 776.745 1743.06 764.914 1743.07 750.212L1743.1 680.979C1743.14 582.009 1827.42 502.535 1929.55 503.954L2085.92 506.128C2184.16 507.493 2262.63 586.119 2262.17 681.272L2261.85 747.841C2261.78 761.975 2250.12 773.507 2235.77 773.602Z",
    fill: "url(#paint9_linear_248_90)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2764.57 2569.9L196.917 2548.01V2612.77C196.917 2630.35 208.116 2645.29 223.283 2647.96L949.339 2775.48C957.956 2776.99 966.695 2777.39 975.389 2776.67L2736.67 2631.28C2752.39 2629.98 2764.57 2614.99 2764.57 2596.93V2569.9Z",
    fill: "#26264F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1832.78 2466.12L223.469 2584.59C194.672 2586.71 171.257 2564.18 171.257 2534.27V1335.86C171.257 1305.95 194.671 1281.7 223.469 1281.7H1832.78C1856.51 1281.7 1875.69 1303.62 1875.69 1330.66V2414C1875.69 2441.04 1856.51 2464.37 1832.78 2466.12Z",
    fill: "#26264F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1858.44 2466.12L249.13 2584.59C220.332 2586.71 196.918 2564.18 196.918 2534.27V1335.86C196.918 1305.95 220.332 1281.7 249.13 1281.7H1858.44C1882.17 1281.7 1901.35 1303.62 1901.35 1330.66V2414C1901.35 2441.04 1882.17 2464.37 1858.44 2466.12Z",
    fill: "url(#paint10_linear_248_90)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1808.31 2389.74L309.401 2492.65C285.966 2494.26 266.922 2475.77 266.922 2451.35V1402.14C266.922 1377.72 285.966 1357.84 309.401 1357.74L1808.31 1351.28C1827.88 1351.19 1843.71 1369.16 1843.71 1391.4V2347.04C1843.71 2369.28 1827.88 2388.4 1808.31 2389.74Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.62 1314.48C1110.62 1325.61 1102.34 1334.67 1092.11 1334.7C1081.87 1334.73 1073.56 1325.71 1073.56 1314.55C1073.56 1303.39 1081.87 1294.34 1092.11 1294.33C1102.34 1294.32 1110.62 1303.34 1110.62 1314.48Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1922.58 2459.55L196.918 2584.25L949.341 2716.4C957.958 2717.91 966.696 2718.31 975.39 2717.6L2764.57 2569.9L1950.03 2460.4C1940.93 2459.17 1931.74 2458.89 1922.58 2459.55Z",
    fill: "url(#paint11_linear_248_90)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M448.719 2585.32L1885.39 2479.96L2330.02 2539.25L905.732 2651.88L448.719 2585.32Z",
    fill: "#26264F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M914.198 2449.37L302.729 2490.51C284.789 2491.72 269.573 2477.5 269.573 2459.51V1388.59C269.573 1371.48 283.407 1357.59 300.517 1357.52L914.198 1355.04L914.198 2449.37Z",
    fill: "#D8DEE8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1703.85 1865.38L1059.6 1888.01V1822.87L1703.85 1802.68V1865.38Z",
    fill: "#D8DEE8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1703.85 1968.09L1059.6 1994.73V1929.59L1703.85 1905.39V1968.09Z",
    fill: "#D8DEE8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M851.128 1877.08L481.189 1889.69V1841L851.128 1829.41V1877.08Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M851.128 1955.18L481.189 1969.45V1920.76L851.128 1907.5V1955.18Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M851.128 2033.27L481.189 2049.21V2000.52L851.128 1985.6V2033.27Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M851.128 2111.37L481.189 2128.97V2080.28L851.128 2063.7V2111.37Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.29 2087.91L1059.6 2101.45V2036.31L1344.29 2023.85V2087.91Z",
    fill: "#D8DEE8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.45 1577.45V1675.3C1298.45 1703.59 1322.25 1725.91 1351.52 1725.15L1424.1 1723.25C1453.02 1722.5 1476.39 1699.19 1476.39 1671.2V1574.37L1298.45 1577.45ZM1365.29 1678.61L1378.78 1637.74C1373 1634.76 1369.09 1628.88 1369.09 1622.04C1369.09 1611.99 1377.51 1603.69 1387.89 1603.5C1398.25 1603.3 1406.65 1611.27 1406.65 1621.29C1406.65 1628.12 1402.75 1634.14 1396.99 1637.36L1410.42 1677.56L1365.29 1678.61Z",
    fill: "#D8DEE8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.76 1565.9C1448.06 1566.03 1441.81 1560.07 1441.81 1552.59C1441.81 1523.82 1417.66 1500.73 1387.89 1501.12C1358.01 1501.5 1333.62 1525.36 1333.62 1554.31C1333.62 1561.84 1327.29 1568.05 1319.47 1568.18C1311.64 1568.31 1305.29 1562.3 1305.29 1554.76C1305.29 1510.71 1342.45 1474.45 1387.89 1473.94C1433.09 1473.43 1469.68 1508.52 1469.68 1552.14C1469.68 1559.61 1463.45 1565.77 1455.76 1565.9Z",
    fill: "#D8DEE8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M249.124 2584.59L1850.29 2466.72L1858.44 2466.12C1869.33 2465.32 1879.23 2459.94 1886.79 2451.77C1771.56 2445.47 1700 2404.58 1653.83 2362.33C1561.12 2277.48 1577.2 2193.81 1477.22 2138.02C1352.53 2068.44 1254.48 2156.61 1159.85 2069.62C1102.48 2016.88 1130.65 1977.55 1060.06 1898.74C981.874 1811.45 930.972 1840.79 852.397 1762.23C753.047 1662.89 802.736 1585.6 717.157 1514.28C613.338 1427.75 501.376 1507.84 402.548 1424.86C359.922 1389.07 336.532 1337.04 324.32 1281.7H249.13C220.332 1281.7 196.917 1305.95 196.917 1335.86V2534.27C196.918 2564.18 220.328 2586.7 249.124 2584.59Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.13 2124.49C1354.04 2105.56 1338.21 2011.39 1292.39 1947.79C1227.33 1857.49 1096.72 1821.73 1072.72 1851.84C1048.15 1882.64 1133.01 1985.2 1146.79 2001.86C1196.8 2062.29 1290.94 2146.89 1325.13 2124.49Z",
    fill: "url(#paint12_linear_248_90)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1642.44 2708.64C1637.27 2715.27 1636.84 2726.81 1642.15 2732.09C1647.37 2737.27 1654.3 2732.58 1674.86 2731.68C1696.89 2730.71 1703.01 2735.48 1717.64 2730.25C1723.55 2728.14 1733.91 2723.3 1733.39 2719.01C1733.03 2715.99 1727.48 2714.83 1708.91 2710.1C1682.55 2703.38 1682.63 2702.9 1677.1 2702.4C1663.22 2701.14 1649.27 2699.88 1642.44 2708.64Z",
    fill: "url(#paint13_linear_248_90)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.88 2671.75L1667.61 2707.6C1666.92 2709.63 1656.2 2717.02 1646.28 2713.57L1627.27 2679.19L1653.88 2671.75Z",
    fill: "url(#paint14_linear_248_90)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1505.43 2751.16C1500.26 2757.8 1499.83 2769.34 1505.14 2774.62C1510.36 2779.8 1517.29 2775.11 1537.85 2774.21C1559.88 2773.24 1566 2778 1580.63 2772.78C1586.54 2770.67 1596.9 2765.83 1596.38 2761.54C1596.01 2758.52 1590.47 2757.36 1571.9 2752.63C1545.54 2745.91 1545.62 2745.43 1540.09 2744.93C1526.21 2743.67 1512.26 2742.41 1505.43 2751.16Z",
    fill: "url(#paint15_linear_248_90)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1516.87 2714.28L1530.6 2750.13C1529.91 2752.16 1519.19 2759.55 1509.26 2756.1L1490.26 2721.72L1516.87 2714.28Z",
    fill: "url(#paint16_linear_248_90)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M831.401 1875.84C865.493 1861.34 917.917 1843.54 983.749 1838.68C1057.87 1833.21 1117.39 1828.81 1161.08 1860.81C1267.12 1938.45 1170.52 2150.34 1238.86 2296.92C1246.35 2312.97 1268.45 2363.99 1256.77 2421.64C1254.62 2432.27 1249.26 2441.73 1240.1 2457.76C1186.31 2551.87 1017.14 2571.76 933.646 2499.79C889.521 2461.75 853.133 2472.01 848.68 2425.21C831.106 2240.5 846.169 2053.84 831.401 1875.84Z",
    fill: "url(#paint17_linear_248_90)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M922.705 2106.5C905.716 2068.86 917.084 2023.5 884.152 2006.5C872.085 2000.27 857.515 1998.33 841.912 1999.83C853.833 2135.66 866.55 2271.31 880.347 2412.97C884.904 2459.76 890.936 2461.65 939.405 2499.36C995.565 2543.07 1087.43 2551.9 1164.09 2530.57C1057.55 2475.44 980.047 2415.89 986.347 2359.48C993.684 2293.78 1110.94 2265.88 1102.76 2220.15C1094.09 2171.7 959.842 2188.79 922.705 2106.5Z",
    fill: "url(#paint18_linear_248_90)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M864.12 1877.63C828.151 1857.03 749.922 1921.46 707.96 1976.19C688.457 2001.62 620.554 2090.17 647.2 2200.42C651.541 2218.38 671.63 2302.39 747.499 2338.67C815.43 2371.14 902.725 2355.04 969.331 2297.01C978.333 2287.75 987.339 2278.49 996.344 2269.23C1005.07 2258.28 1013.79 2247.33 1022.51 2236.38C1006.69 2225.09 980.051 2209.08 943.643 2200.23C888.165 2186.75 854.459 2215.33 840.237 2199.21C822.727 2179.36 868.405 2136.6 874.563 2046.54C876.225 2022.24 904.297 1900.63 864.12 1877.63Z",
    fill: "url(#paint19_linear_248_90)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M963.334 2455.39C946.141 2530.74 985.844 2497.69 1068.1 2449.32C1154.74 2398.38 1346.57 2320.24 1437.42 2397.3C1505.08 2454.7 1467.71 2556.12 1573.28 2656.91C1591.87 2674.66 1609.15 2686.75 1619.9 2693.7C1636.95 2685.13 1653.99 2676.55 1671.04 2667.97C1674.96 2627.17 1685.21 2470.23 1577.17 2338.35C1551.05 2306.46 1501.31 2245.21 1422.35 2223.58C1208.88 2165.1 979.189 2385.9 963.334 2455.39Z",
    fill: "url(#paint20_linear_248_90)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M875.248 2392.79C863.719 2436.19 880.506 2483.85 906.688 2512.3C964.808 2575.44 1083.63 2559.57 1156.35 2529.28C1244.82 2492.44 1261.02 2436.06 1297.69 2446.91C1354.67 2463.78 1325.32 2603.18 1433.55 2706.51C1452.15 2724.27 1469.42 2736.35 1480.17 2743.31C1497.22 2734.73 1514.27 2726.16 1531.31 2717.58C1537.66 2622.77 1522.4 2548.31 1508.73 2501.04C1493.06 2446.83 1479.03 2398.27 1436.71 2353.56C1384.14 2298.01 1319.61 2281.91 1282.63 2273.19C1126.15 2236.27 905.202 2280.02 875.248 2392.79Z",
    fill: "url(#paint21_linear_248_90)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.6 2241.73L949.34 2266.08L1063.03 2310.95L1365.65 2268.57L1362.6 2241.73Z",
    fill: "url(#paint22_linear_248_90)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M935.582 2278.13V2278.13C936.153 2285.86 941.498 2292.4 948.953 2294.5L1084.68 2336.46L1082.63 2300.57L949.341 2266.08C941.888 2264.53 935.021 2270.54 935.582 2278.13Z",
    fill: "url(#paint23_linear_248_90)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M993.292 2257.2C990.717 2256.83 1003.4 2226.09 1015.33 2228.64C1027.26 2231.2 1086.83 2260.08 1093.03 2273.33C1099.23 2286.57 1099.23 2286.57 1099.23 2286.57C1099.23 2286.57 1074.45 2290.36 1058.62 2286.31C1042.78 2282.26 1014.23 2260.28 993.292 2257.2Z",
    fill: "url(#paint24_linear_248_90)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.99 2048.22L1065.48 2315.31C1065.15 2324.53 1078.95 2337.2 1088.11 2336.08L1513.03 2278.33C1520.02 2277.47 1525.48 2271.88 1526.16 2264.87L1560.82 2005.03C1561.73 1995.6 1544.28 1987.22 1534.86 1988.18L1088.46 2033.82C1081 2034.59 1075.26 2040.73 1074.99 2048.22Z",
    fill: "url(#paint25_linear_248_90)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.32 2055.22L1075.8 2322.31C1075.47 2331.53 1083.46 2338.86 1092.61 2337.75L1523.36 2285.33C1530.35 2284.48 1535.81 2278.88 1536.49 2271.88L1561.65 2011.56C1562.56 2002.13 1554.61 1994.22 1545.18 1995.19L1098.79 2040.83C1091.33 2041.59 1085.58 2047.74 1085.32 2055.22Z",
    fill: "url(#paint26_linear_248_90)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1353.85 2235.44C1314.92 2222.23 1325.99 2190.74 1278.61 2156.02C1216.1 2110.22 1157.78 2136.4 1133.92 2099.08C1126.5 2087.46 1121.98 2068.85 1131.11 2037.52L1098.79 2040.83C1091.33 2041.59 1085.58 2047.73 1085.32 2055.22L1075.8 2322.31C1075.48 2331.53 1083.46 2338.86 1092.61 2337.75L1523.36 2285.33C1530.35 2284.48 1535.81 2278.88 1536.49 2271.88L1539.96 2235.96C1526.3 2229.63 1510.14 2224.15 1491.58 2221.79C1427.21 2213.62 1398.66 2250.64 1353.85 2235.44Z",
    fill: "url(#paint27_linear_248_90)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M983.184 1736.9C985.445 1764.36 983.99 1786.38 982.193 1801.52C980.135 1818.86 978.068 1823.46 975.278 1827.27C971.078 1833.01 964.444 1838.05 925.791 1850.72C904.757 1857.61 901.99 1857.67 901.673 1859.84C900.132 1870.38 961.172 1901.41 1020.9 1888.43C1057.46 1880.48 1089.52 1856.92 1086.63 1846.01C1083.74 1835.02 1047.27 1843.73 1034.79 1824.39C1026.1 1810.94 1033.2 1790.4 1042.12 1773.17C1030.95 1755.5 994.362 1754.57 983.184 1736.9Z",
    fill: "url(#paint28_linear_248_90)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.29 1766.11C1073.98 1756.26 1078.16 1736.42 1070.56 1722C1064.01 1709.59 1050.88 1705.59 1043.02 1703.19C1020.23 1696.24 989.08 1700.58 974.942 1720.14C966.565 1731.73 974.833 1760.5 976.015 1765.62C977.356 1771.41 981.228 1774.02 984.381 1778.79C988.75 1785.4 995.564 1795.89 1006.62 1813.37C1008.5 1809.15 1011.13 1803.98 1014.8 1798.54C1016.21 1796.44 1021.84 1788.27 1029.25 1782C1044.09 1769.43 1053.16 1775.45 1063.29 1766.11Z",
    fill: "url(#paint29_linear_248_90)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M989.246 1797.19C989.246 1797.19 999.956 1825.1 1030.79 1828.69C1058.39 1831.91 1073.58 1771.46 1058.54 1755.29C1053.51 1749.9 1042.2 1745.97 1032.25 1746.89C1026.37 1747.43 1024.05 1749.41 1014.43 1750.11C1005.56 1750.76 1003.34 1749.38 1000.38 1751.06C996.693 1753.17 993.142 1759.34 995.211 1778.2C990.97 1771.98 985.093 1768.82 980.284 1770.1C979.517 1770.3 977.411 1771.23 976.003 1772.97C970.909 1779.26 975.657 1789.35 989.246 1797.19Z",
    fill: "url(#paint30_linear_248_90)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M999.82 1747.18C1000.96 1748.4 996.036 1752.57 994.465 1759.47C991.414 1772.84 1002.1 1791.53 1015.77 1795.45C1023.86 1797.77 1027.03 1793.22 1040.9 1794.27C1049.49 1794.92 1056.31 1797.28 1060.54 1799.05C1062.11 1814.62 1055.39 1828.63 1044.25 1833.67C1032.26 1839.08 1019.49 1832.13 1014.14 1829.22C1010.57 1827.27 999.114 1821.06 994.79 1808.73C990.286 1795.87 998.081 1790.04 991.91 1780.77C988.798 1776.1 984.07 1773.45 980.568 1764.86C979.616 1762.53 979.065 1760.52 978.748 1759.18C987.153 1753 998.175 1745.41 999.82 1747.18Z",
    fill: "url(#paint31_linear_248_90)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.64 1802.72C1049.64 1802.72 1043.18 1804.72 1033.11 1802.29C1032.62 1802.17 1032.04 1802.21 1031.93 1802.46C1031.52 1803.38 1037.26 1808.9 1043.59 1808.31C1048.08 1807.89 1052.15 1804.46 1051.76 1803.32C1051.6 1802.85 1050.62 1802.73 1049.64 1802.72Z",
    fill: "url(#paint32_linear_248_90)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_90",
    x1: 924.949,
    y1: 297.475,
    x2: 1069.16,
    y2: 1603.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_248_90",
    x1: -15.2193,
    y1: 541.965,
    x2: 1030.51,
    y2: 1962.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_248_90",
    x1: 373.19,
    y1: 397.134,
    x2: 927.282,
    y2: 1505.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_248_90",
    x1: 2784.05,
    y1: -11.2534,
    x2: 2370.19,
    y2: 386.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_248_90",
    x1: 1655.35,
    y1: 1298.13,
    x2: 948.278,
    y2: 2476.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_248_90",
    x1: 2299.96,
    y1: 1389.45,
    x2: 1157.42,
    y2: -907.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_248_90",
    x1: 1442.79,
    y1: 943.759,
    x2: 2545.97,
    y2: 943.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_248_90",
    x1: 2345.77,
    y1: 374.586,
    x2: 1892.05,
    y2: 1213.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_248_90",
    x1: 1939.77,
    y1: 927.115,
    x2: 2097.55,
    y2: 1171.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_248_90",
    x1: 2214.67,
    y1: 303.661,
    x2: 1760.95,
    y2: 1142.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_248_90",
    x1: 196.917,
    y1: 1933.21,
    x2: 1901.35,
    y2: 1933.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_248_90",
    x1: 196.917,
    y1: 2588.57,
    x2: 2764.57,
    y2: 2588.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_248_90",
    x1: 1176.52,
    y1: 2022.79,
    x2: 1226.8,
    y2: 1948.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_248_90",
    x1: 1727.16,
    y1: 2701.34,
    x2: 1640.97,
    y2: 2732.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_248_90",
    x1: 1673.7,
    y1: 2719.43,
    x2: 1615.01,
    y2: 2652.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_248_90",
    x1: 1590.15,
    y1: 2743.87,
    x2: 1503.96,
    y2: 2774.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_248_90",
    x1: 1536.69,
    y1: 2761.96,
    x2: 1478,
    y2: 2695.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_248_90",
    x1: 898.661,
    y1: 2369.82,
    x2: 1100.17,
    y2: 2071.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_248_90",
    x1: 925.553,
    y1: 2379.71,
    x2: 1125.14,
    y2: 2084.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_248_90",
    x1: 755.888,
    y1: 2267.11,
    x2: 960.836,
    y2: 1964.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_248_90",
    x1: 1233.85,
    y1: 2680.19,
    x2: 1511.73,
    y2: 2269.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_248_90",
    x1: 1389.9,
    y1: 2308.17,
    x2: 1063.34,
    y2: 2728.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_248_90",
    x1: 1230.13,
    y1: 2423.11,
    x2: 1169.74,
    y2: 2285.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_248_90",
    x1: 996.833,
    y1: 2234.25,
    x2: 1024.49,
    y2: 2359.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_248_90",
    x1: 993.387,
    y1: 2262.37,
    x2: 1096.87,
    y2: 2254.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_248_90",
    x1: 1360.46,
    y1: 2218.51,
    x2: 1252.88,
    y2: 2087.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_248_90",
    x1: 1190.61,
    y1: 2461.12,
    x2: 1371.7,
    y2: 2012.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_248_90",
    x1: 1066.01,
    y1: 2191.03,
    x2: 1534.08,
    y2: 2156.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_248_90",
    x1: 954.995,
    y1: 1954.32,
    x2: 1055.63,
    y2: 1697.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_248_90",
    x1: 938.686,
    y1: 1874.62,
    x2: 1039.06,
    y2: 1711.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_248_90",
    x1: 1021.83,
    y1: 1759.06,
    x2: 988.558,
    y2: 2016.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_248_90",
    x1: 958.258,
    y1: 1886.78,
    x2: 1058.74,
    y2: 1723.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_248_90",
    x1: 1044.78,
    y1: 1793.22,
    x2: 1035.45,
    y2: 1824.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12291123WavyTech24Single01);
export default __webpack_public_path__ + "static/media/12291123_Wavy_Tech-24_Single-01.0eda90ecad8a51f744a15e33e5178601.svg";
export { ForwardRef as ReactComponent };